var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const doesNodeExist = (nodeId, editorCommands) => editorCommands == null ? void 0 : editorCommands.getAllBlocksKeys().includes(nodeId);
class UpdateService {
  setEditorCommands(editorCommands) {
    this.EditorCommands = editorCommands;
  }
  updatePluginData(uploadedData, nodeId, type, mediaPluginService, fileState) {
    var _a, _b;
    if (doesNodeExist(nodeId, this.EditorCommands)) {
      const componentData = (_a = this.EditorCommands) == null ? void 0 : _a.getBlockComponentData(nodeId);
      const newComponentData = mediaPluginService.createPluginData(
        uploadedData,
        componentData,
        fileState
      );
      (_b = this.EditorCommands) == null ? void 0 : _b.setBlock(nodeId, type, newComponentData, {
        isRicosSchema: true
      });
    }
  }
  updateLoadingState(url, file, nodeId, type, mediaPluginService, fileState) {
    var _a, _b;
    if (doesNodeExist(nodeId, this.EditorCommands)) {
      const currentComponentData = (_a = this.EditorCommands) == null ? void 0 : _a.getBlockComponentData(nodeId);
      const {
        componentState,
        componentData,
        fileState: newFileState
      } = mediaPluginService.createLoadingData(file, url, currentComponentData, fileState);
      (_b = this.EditorCommands) == null ? void 0 : _b.setBlock(
        nodeId,
        type,
        __spreadValues(__spreadValues({}, componentData), componentState),
        {
          isRicosSchema: true
        }
      );
      return newFileState;
    }
  }
  updateErrorState(error, nodeId, type, mediaPluginService, fileState) {
    var _a, _b;
    if (doesNodeExist(nodeId, this.EditorCommands)) {
      const componentData = (_a = this.EditorCommands) == null ? void 0 : _a.getBlockComponentData(nodeId);
      const newComponentData = mediaPluginService.createErrorData(error, componentData, fileState);
      (_b = this.EditorCommands) == null ? void 0 : _b.setBlock(nodeId, type, newComponentData);
    }
  }
}

export { UpdateService };
//# sourceMappingURL=UpdateService.js.map
